import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
    providedIn: 'root'
})

export class ThemeService {

    public currentThemeName: string = "";

    public constructor(@Inject(DOCUMENT) private document: Document) { }

    public loadTheme(themeName: string) {

        const head = this.document.getElementsByTagName("head")[0];
        const themeSource = this.document.getElementById("client-theme") as HTMLLinkElement;

        if (themeSource) {

            themeSource.href = themeName + ".css";

        } else {

            const style = this.document.createElement("link");

            style.id = "client-theme";
            style.rel = "stylesheet";
            style.href = themeName + ".css";

            head.appendChild(style);
        }

        this.currentThemeName = themeName;
    }
}
